import { Box, Dialog, DialogActions, DialogContent, Grid, TextField, Typography } from "@mui/material";
import { FC, useCallback, useState } from "react";
import { MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO } from "src/App";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import api, { STATUS_CODE } from "src/framework/providers/api";
import { notifierStore } from "src/framework/store/NotifierStore";

interface ModalFinalizarProjetoManualParams {
    open: boolean;
    closeModal: () => void;
    projetoId: number
    onSuccess: () => void
}

export const ModalFinalizarProjetoManual: FC<ModalFinalizarProjetoManualParams> = ({ open, closeModal, projetoId, onSuccess}) => {
    const [observacao, setObservacao] = useState("");

    const onConfirm = useCallback(async () => {
        if (!projetoId || !observacao) return;

        const response = await api.post({
            url: "/projetos/finalizar_manual",
            data: {
                id: projetoId,
                observacao_faturamento_renovigi: observacao,
            }
        })

        if (response.statusCode === STATUS_CODE.OK) {
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: ["Projeto finalizado com sucesso!"],
                timeOut: 4000,
                onClose: () => {
                    notifierStore.setOpen(false);
                    onSuccess();
                    closeModal();
                }
            });
            notifierStore.setOpen(true);
        } else {
            const content:string[] = [];
            content.push('Não foi possível finalizar o projeto.')
            if (response?.message) {
                if (Array.isArray(response?.message)) {
                    response?.message.forEach((m:string) => content.push(m));
                } else if (typeof response?.message === "string") {
                    content.push(response?.message);
                }
            }

            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: content,
                timeOut: 3500,
                onClose: () => {
                    const mensagemVigencia = content?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO) || content?.some((message:any) => message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO));
                    if (mensagemVigencia) window.location.href = `${window.location.origin}/projetos/menu-projetos`;
                    notifierStore.setOpen(false);
                }
            });
            notifierStore.setOpen(true);
        }
    }, [projetoId, observacao])

    return (
        <Dialog
            open={open}
            onClose={closeModal}
            maxWidth='sm'
        >
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Box component={"h2"}>Atenção!</Box>
                            <Typography variant="subtitle2" color="textSecondary">Ao finalizar um projeto manualmente, nenhuma informação será sincronizada, por isso, é importante detalhar o máximo de dados no campo abaixo:</Typography>
                            <TextField
                                value={observacao}
                                onChange={e => setObservacao(e.target.value)}
                                style={{ marginTop: 10, marginBottom: 10 }}
                                multiline
                                variant="outlined"
                                fullWidth
                                minRows={10}
                                InputProps={{
                                    inputProps: {
                                      maxLength: 300,
                                    },
                                  }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ marginBottom: 10 }}>
                <FlatButton
                    color="inherit"
                    variant="contained"
                    disableElevation
                    text="Fechar"
                    onClick={closeModal}
                />
                <FlatButton
                    color="primary"
                    variant="contained"
                    disableElevation
                    disabled={!observacao || !projetoId}
                    text="Confirmar"
                    onClick={onConfirm}
                />
            </DialogActions>
        </Dialog>
    )
}

